import V2Container from '@/common/components/Data/V2Container';
import { FC, useEffect, useRef, useState } from 'react';
import { useGlobalAliases } from '@/common/hook/useGlobalAlias';
import styles from './index.module.less';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import Main from './components/Main';
import Header from './components/Header';
import { getSpotSurveyDetail } from '@/common/api/expandStore/spotSurvey';

/**
 * @Description 踩点详情
 */
const SpotSurveyDetail: FC<{
  id,
  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  shareData?,
  isSjtb?: boolean; // 三津汤包
}> = ({ id, shareData,
  isSjtb
}) => {
  const headerRef = useRef<any>();
  const [mainHeight, setMainHeight] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false); // 加载中
  const [detail, setDetail] = useState<any>({});
  const [refreshChanceFlag, setRefreshChanceFlag] = useState<number>(0);

  /** 获取全局别名 */
  const {
    standardChancePoint: standardChancePointAlias, // 机会点别名
    standardTask: standardTaskAlias, // 拓店任务别名
  } = useGlobalAliases();

  useEffect(() => {
    id && methods.loadDetail();
  }, [id]);

  const methods = useMethods({
    loadDetail() {
      setLoading(true);
      getSpotSurveyDetail({ id }).then((res) => {
        setDetail(res);
      }).finally(() => {
        setLoading(false);
      });
    }
  });

  return (
    <V2Container
      style={{ height: '100vh' }}
      emitMainHeight={h => setMainHeight(h)}
      className={styles.container}
      extraContent={{
        top: <Header
          headerRef={headerRef}
          detail={detail}
          isShare={!!shareData}
          isSjtb={isSjtb}
          shareData={shareData}
          standardChancePointAlias={standardChancePointAlias}
          setRefreshChanceFlag={setRefreshChanceFlag}
        />
      }}
    >
      <div>
        <Spin spinning={loading}>
          <Main
            mainHeight={mainHeight}
            headerRef={headerRef}
            detail={detail}
            standardChancePointAlias={standardChancePointAlias}
            standardTaskAlias={standardTaskAlias}
            disabled={!!shareData}
            isSjtb={isSjtb}
            shareData={shareData}
            refreshChanceFlag={refreshChanceFlag}
          />
        </Spin>
      </div>
    </V2Container>

  );
};

export default SpotSurveyDetail;
